module.exports = __webpack_public_path__ + "img/result-contact-btn.16b6feb6.png";